import React from "react";

function Brokerage() {
    return ( 
        <h1>Brokerages</h1>
     );
}

export default Brokerage;